class RecipeDetails {
  DB;
  recipe;
  getItemsByFindParams;
  mountShelBlock;
  masterdata;
  slug: string;
  numberOfRelatedProducts = 3; // número de produtos para exibir

  readonly config = {
    selectors: {
      recipeDetailsTemplate: '#detalhes-receitas',
      recipeDetailsContainer: '[data-type="container-detalhes-receitas"]',
      recipeRelateds: '[data-shelf-type="receitas-similares"]',
      recipeRelatedItem: '#produto-relacionado-receita',
      recipeRelatedContainer: '[data-type="container-produtos-relacionados"]',
    },
  };

  private templateRender = {
    recipesTemplate: (obj) => {
      return window.storeTheme.helpers.mustache.render(
        document.querySelector(this.config.selectors.recipeDetailsTemplate)?.innerHTML || '',
        obj,
      );
    },
    recipeRelatedItem: (obj) => {
      return window.storeTheme.helpers.mustache.render(
        document.querySelector(this.config.selectors.recipeRelatedItem)?.innerHTML || '',
        obj,
      );
    },
  };

  constructor(props) {
    this.DB = props.DB;
    this.slug = props.slug;
    this.masterdata = props.masterdata;
    this.mountShelBlock = props.mountShelBlock;
    this.getItemsByFindParams = props.getItemsByFindParams;
    this.recipe = {};

    const template = document.querySelector(this.config.selectors.recipeDetailsTemplate)?.innerHTML || '';
    if (!template) {
      console.warn('🥩 Template para detalhe de receitas não está disponível nesta página');
    }

    window.storeTheme.helpers.mustache.parse(template);

    if (props.updateRecipeData ?? true) {
      this.getCompleteRecipeData();
    }

    this.bindEvents();
  }

  async getCompleteRecipeData() {
    const exist = await this.getRecipeBySlug();

    if (exist) {
      console.log(this.recipe);
      if (this.recipe?.urlVersion !== '2') {
        this.mountTitle();
        this.renderReciple();
      }
      this.getRelatedProducts();
      this.mountShelfBlockRelated();
    }
  }

  mountTitle() {
    const title = `${this.recipe.name} - Receitas Swift`;
    try {
      document.querySelector('title').innerHTML = title;
      document.querySelector('meta[property="og:title"]').innerHTML = title;
      document.querySelector('meta[property="og:description"]').innerHTML = title;
      document.querySelector('meta[name="description"]').innerHTML = title;
    } catch (e) {
      console.error(e);
    }
  }

  /**
   * Aplica os triggers de eventos para a página
   */
  bindEvents() {
    const $document = $(document);
    $document.on('click', '[data-video]', (event) => {
      event.preventDefault();
      const $element = $(event.currentTarget);
      const videoId = event.currentTarget.getAttribute('data-youtube-id');
      if (videoId) {
        // @ts-ignore
        const player = new window.YT.Player(event.currentTarget, {
          height: '460',
          width: '670',
          videoId: videoId,
          playerVars: {
            showinfo: 0,
            modestbranding: 0,
            listType: 'user_uploads',
            list: 'UCx_DnTAyLKfvLj5r788zXng',
          },
          events: {
            onReady: () => {
              player.playVideo();
            },
          },
        });
      }
    });

    $document.on('click', '[data-type="container-produtos-relacionados"] .btn-veja-mais', (event) => {
      event.preventDefault();
      const $element = event.currentTarget;
      const $items = $element.previousElementSibling.children as HTMLAnchorElement[];
      const $btnBuyAll = document.querySelector('.buy-all-items');

      $btnBuyAll.classList.remove('d-none');
      [].forEach.call($items, function (el) {
        el.classList.remove('hidden-from-up');
      });
      $element.style.display = 'none';
    });
    $document.on('click', '[data-type="container-produtos-relacionados"] .buy-all-items', (event) => {
      event.preventDefault();
      const $element = event.currentTarget;
      const $btnSeeAll = $element.previousElementSibling;
      const $itemsProd = $btnSeeAll.previousElementSibling.children as HTMLAnchorElement[];
      let listProducts = Array.from($itemsProd).map((item) => {
        let link = item.querySelector('.BottomBuy a');
        let qtItem = item.querySelector('.c-quantidade').getAttribute('value');
        const url = window.storeTheme.helpers.url.getJsonFromUrl(link.getAttribute('href'));

        return {
          id: url.sku,
          quantity: qtItem,
          seller: url.seller,
        };
      });
      vtexjs.checkout.addToCart(listProducts, null, window.Cookies.get('VTEXSC').replace('sc=', ''));
    });
  }

  renderReciple() {
    const objDom = document.querySelector(this.config.selectors.recipeDetailsContainer);

    if (objDom) {
      objDom.innerHTML = this.templateRender.recipesTemplate(this.recipe);
    }
  }

  async getRecipeBySlug() {
    this.recipe = this.DB.getCollection('receitas').findOne({ visible: { $eq: true }, slug: { $eq: this.slug } });

    if (!this.recipe) {
      window.location.href = `/Sistema/404?recipeNotFound=${this.slug}`;
      return false;
    }

    if (this.recipe && !this.recipe?.full) {
      // se não tem o dado completo, vamos buscar para atualizar a receita localmente

      // buscar complemento de receitas
      const data = await this.masterdata.receitas.get({
        fields: [
          'video',
          'additionalImage1',
          'additionalImage2',
          'hint',
          'ingredientsList',
          'preparationMode',
          'preparationTime',
          'relatedReceipt1',
          'relatedReceipt2',
          'relatedReceipt3',
          'relatedReceipt4',
          'relatedReceipt5',
          'relatedReceipt6',
          'downloadLink',
        ].join(),
        where: `slug=${this.slug}`,
      });

      if (data?.length) {
        const recipleData = data.shift();
        const downloadLink = recipleData.downloadLink
          ? `/${window.jsnomeLoja}/dataentities/RR/documents/${this.recipe.id}/downloadLink/attachments/${recipleData.downloadLink}`
          : '';
        this.updateRecipeData({
          ...recipleData,
          downloadLink,
          videoId: window.storeTheme.helpers.url.getVideoIdFromUrl(recipleData.video),
          full: true,
        });

        return true;
      }
    }

    return !!this.recipe;
  }

  /**
   * Atualiza complemento de informações para receita que está sendo visualizada
   * @param recipeData
   */
  updateRecipeData(recipeData) {
    Object.assign(this.recipe, recipeData);

    ['hint', 'ingredientsList', 'preparationMode'].forEach((key) => {
      if (this.recipe?.[key]) {
        this.recipe[key] = this.recipe[key].split('\n');
      }
    });

    this.DB.getCollection('receitas').update(this.recipe);
    this.DB.saveDatabase();
  }

  /**
   * Captura produtos relacionados e monta prateleira destes
   */
  async getRelatedProducts() {
    const $box = document.querySelector(this.config.selectors.recipeRelatedContainer);
    if (!$box) {
      return;
    }

    if (this.recipe?.relatedProducts?.length) {
      const productIds = this.recipe.relatedProducts;
      

      if (productIds.length) {
        let hasBtnMore = false;

        let ids = Object.values(
          await window.storeTheme.helpers.getSkuInfoByProductList(productIds, 'productId'),
        ).filter((item) => {
          return !!item.available;
        });

        let skus = Object.values(await window.storeTheme.helpers.getSkuInfoByProductList(productIds, 'skuId')).filter(
          (item) => {
            return !!item.available;
          },
        );
          

        const produtosRelacionados = [...ids, ...skus].map((element, index) => {
          if (this.numberOfRelatedProducts < index + 1) {
            Object.assign(element, { classNames: 'hidden-from-up' });
            hasBtnMore = true;
          }

          return element;
        });

        if (produtosRelacionados.length) {
          const result = this.templateRender.recipeRelatedItem({ items: produtosRelacionados });
          $box.innerHTML = result;
          if (hasBtnMore) {
            const $btn = $box.querySelector('.btn-veja-mais');
            if ($btn) {
              $btn.classList.remove('d-none');
            }
          }
          return;
        }
      }
    }
    // clear loading
    $box.innerHTML = '';
  }

  /**
   * Monta prateleira de receitas relacionadas
   */
  async mountShelfBlockRelated() {
    const shelf = document.querySelector(this.config.selectors.recipeRelateds);
    if (shelf) {
      const {
        relatedReceipt1,
        relatedReceipt2,
        relatedReceipt3,
        relatedReceipt4,
        relatedReceipt5,
        relatedReceipt6,
      } = this.recipe;
      const recipeAvailable = [
        relatedReceipt1,
        relatedReceipt2,
        relatedReceipt3,
        relatedReceipt4,
        relatedReceipt5,
        relatedReceipt6,
      ].filter((item) => !!item);

      let $and: any[] = [
        {
          slug: { $ne: this.slug },
        },
        {
          $or: [
            {
              categoryId: { $eq: this.recipe.categoryId },
            },
          ],
        },
      ];

      if (recipeAvailable.length) {
        $and[1].$or.push({
          id: { $in: recipeAvailable },
        });
      }

      let items = await this.getItemsByFindParams({
        $and,
      });

      if (items.length < 4) {
        let $filter = {};
        if (items.length) {
          $filter = {
            id: { $nin: items.map((item) => item.id) },
          };
        }
        items = items.concat(await this.getItemsByFindParams($filter));
      }

      this.mountShelBlock(shelf, items.slice(0, 4), undefined, { classNames: 'col-6 col-xl-3' });
    }
  }
}

export default RecipeDetails;
